import { render, staticRenderFns } from "./TaLpData.vue?vue&type=template&id=6a62de21&scoped=true"
import script from "./TaLpData.vue?vue&type=script&lang=js"
export * from "./TaLpData.vue?vue&type=script&lang=js"
import style0 from "./TaLpData.vue?vue&type=style&index=0&id=6a62de21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a62de21",
  null
  
)

export default component.exports